"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightSeatsLabelColumn = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
const Column_1 = require("../../../TariffsTable/Column");
const Tooltip_1 = require("../../../Tooltip");
const utils_1 = require("./utils");
const _1 = require(".");
const getLabel = (key) => {
    const labelMap = {
        totalSeats: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:NumberOfSeats', defaultMessage: 'Seats number' })),
        costPerSeat: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:CostPerSeat', defaultMessage: 'Cost per seat' })),
        agentSeatsLimit: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:AgentSeatsLimit', defaultMessage: 'Seat limit agent' }),
            react_1.default.createElement("span", { className: `${_1.className}__cell-hint` },
                react_1.default.createElement(Tooltip_1.Tooltip, { text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:AgentSeatsLimitHint', defaultMessage: 'Defines the maximum number of seats that can be booked by agents.' })) },
                    react_1.default.createElement(Icon_1.Icon, { name: 'info-circle' }))))),
        onlineSeatsLimit: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:OnlineSeatsLimit', defaultMessage: 'Seat limit online' }),
            react_1.default.createElement("span", { className: `${_1.className}__cell-hint` },
                react_1.default.createElement(Tooltip_1.Tooltip, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:OnlineSeatsLimitHint', defaultMessage: 'Defines the maximum number of seats that can be booked by online users.' }) },
                    react_1.default.createElement(Icon_1.Icon, { name: 'info-circle' }))))),
    };
    return labelMap[key];
};
const FlightSeatsLabelColumn = (props) => {
    const { config } = props;
    const createCell = (key) => {
        var _a, _b;
        const classNames = (0, classFunctions_1.getClassNames)(`${_1.className}__cell-label`, [
            ((_b = (_a = config === null || config === void 0 ? void 0 : config[key]) === null || _a === void 0 ? void 0 : _a.restrictions) === null || _b === void 0 ? void 0 : _b.required) ? 'required' : undefined,
        ]);
        const content = (react_1.default.createElement("div", { className: classNames }, getLabel(key)));
        return { content };
    };
    const cells = [
        {
            content: '',
        },
        ...utils_1.seatsTariffOrder
            .filter(key => { var _a; return !((_a = config === null || config === void 0 ? void 0 : config[key]) === null || _a === void 0 ? void 0 : _a.hidden); })
            .map(createCell),
    ];
    return (react_1.default.createElement(Column_1.TariffsTableColumn, { cells: cells, isLabel: true }));
};
exports.FlightSeatsLabelColumn = FlightSeatsLabelColumn;
//# sourceMappingURL=LabelColumn.js.map